import React, { useEffect } from "react";
import {
  PublicClientApplication,
  EventType,
  InteractionType,
} from "@azure/msal-browser";
import { clientId, redirectUri, authority, scopes } from "./AuthConfig";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import { apiFetch } from "./apiFetch";

const AuthButton = (props) => {
  const isLogin = async (token, name) => {
    try {
      apiFetch(
        process.env.REACT_APP_WEB_SERVICE_URL +
          `/api/Login/Login?username=${
            process.env.REACT_APP_ENV == "http://localhost:3000"
              ? "nurshakina@mmhe.com.my"
              : name
          }`,
        {
          method: "POST",
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        }
      )
        .then((response) => {
          if (response.status === 200) {
            return response.json();
          } else if (response.status === 401) {
            props.dispatch({ type: "Token", value: "" });
            props.dispatch({ type: "userType", value: "" });
            props.dispatch({ type: "userName", value: "" });
            props.dispatch({ type: "UserId", value: "" });

            toast.error(" Incorrect username or password.", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 2000,
            });
          }
        })
        .then((profile) => {
          if (profile) {
            props.dispatch({
              type: "Token",
              value: token,
            });
            props.dispatch({
              type: "userType",
              value: profile?.resultObject?.userType,
            });
            props.dispatch({
              type: "userName",
              value: profile?.resultObject?.name,
            });
            props.dispatch({
              type: "UserId",
              value: profile?.resultObject?.employeeid,
            });
            if (profile?.resultObject?.employeeid) {
              toast.success("Login successfully.", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
              });
            } else {
              toast.error(" Incorrect username or password.", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
              });
            }
          }
        })
        .catch((error) => {
          toast.error("Something went wrong! please try again", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
          console.log(error);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const handleSSO = () => {
    const msalInstance = new PublicClientApplication({
      auth: {
        clientId: clientId,
        redirectUri: redirectUri,
        authority: authority,
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false,
      },
    });

    const handleLoginCompletion = (response) => {
      if (response.payload?.accessToken) {
        isLogin(
          response?.payload?.accessToken,
          response?.payload?.account?.username
        );
      } else if (response.eventType === EventType.LOGIN_FAILURE) {
        toast.error("Please login with correct Microsoft credentails", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 2000,
        });
        console.log("Authentication failed or canceled.", response);
      }
    };

    msalInstance.addEventCallback(handleLoginCompletion);

    const loginPopup = async () => {
      try {
        await msalInstance.loginPopup({
          scopes: scopes,
          interactionType: InteractionType.Popup,
        });
      } catch (error) {
        console.log("Error opening popup window:", error);
      }
    };
    loginPopup();
  };

  return (
    <div className="newHome d-flex justify-content-center align-items-center">
      <div className="card d-flex justify-content-center align-items-center">
        <img src="/assets/images/logo/GGP-logo.png"></img>
        <section className="d-flex flex-column justify-content-center align-items-center w-100">
          <h6>Welcome to E-GGP</h6>
          <button className="btn" onClick={handleSSO}>
            Login
          </button>
        </section>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    menuVisibility: state.menuVisibility,
    menuStatusHeader: state.menuStatusHeader,
    getToken: state.token,
    userType: state.userType,
    userName: state.userName,
    UserId: state.UserId,
  };
};

export default connect(mapStateToProps)(AuthButton);
